import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const NO_REFRESH = /\/auth\/(login|register|refresh|demo-login|mfa\/verify|forgot-password|reset-password)/;
let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && cfg && !cfg._retry && !NO_REFRESH.test(cfg.url)) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  },
);

const PYDANTIC_FR = [
  [/String should have at least (\d+) characters?/, "Au moins $1 caractère(s) requis"],
  [/String should have at most (\d+) characters?/, "$1 caractères maximum"],
  [/Input should be greater than or equal to ([\d.]+)/, "La valeur doit être au moins $1"],
  [/Input should be greater than ([\d.]+)/, "La valeur doit être supérieure à $1"],
  [/Input should be less than or equal to ([\d.]+)/, "La valeur doit être au plus $1"],
  [/Input should be a valid number.*/, "Nombre invalide"],
  [/Input should be a valid integer.*/, "Nombre entier attendu"],
  [/String should match pattern.*/, "Format invalide"],
  [/value is not a valid email address.*/i, "Adresse email invalide"],
  [/Field required/, "Champ obligatoire"],
  [/Input should be .*/, "Valeur non autorisée"],
  [/Value error, /, ""],
  [/List should have at most (\d+) items?.*/, "$1 éléments maximum"],
];
const toFr = (msg) => PYDANTIC_FR.reduce((m, [re, fr]) => m.replace(re, fr), String(msg || ""));

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.response ? "Une erreur est survenue. Réessayez." : "Connexion impossible. Vérifiez votre réseau.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => toFr(d?.msg) || "Valeur invalide").join(" · ");
  return toFr(detail.msg) || String(detail);
}
